import { useState } from "react";
import { ArrowUpRight, ArrowRight, Layers3 } from "lucide-react";
import { useAuth } from "../config/AuthContext";
export default function AuthPage() {
  const [mode, setMode] = useState("login");
  const [values, setValues] = useState({ name: "", email: "", password: "" });
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const { authenticate } = useAuth();
  async function submit(event) {
    event.preventDefault();
    setError("");
    setBusy(true);
    try {
      await authenticate(mode, values);
    } catch (e) {
      setError(e.message);
    } finally {
      setBusy(false);
    }
  }
  return (
    <div className="auth-page">
      <section className="auth-story">
        <a href="/" className="brand">
          forma<span>®</span>
        </a>
        <div className="auth-copy">
          <span className="eyebrow">
            A LITTLE STRUCTURE. A LOT OF POSSIBILITY.
          </span>
          <h1>
            Good ideas.
            <br />
            Beautifully
            <br />
            <em>organized.</em>
          </h1>
          <p>
            Your creative process, all in one place.
            <br />
            Plan, preview, and bring your next story to life.
          </p>
        </div>
        <div className="auth-collage">
          <img
            src="/creatives/room.jpg"
            alt="A thoughtfully styled living room"
          />
          <img src="/creatives/slow.svg" alt="Slow is a beautiful way to go" />
          <img src="/creatives/plant.jpg" alt="Green plant in warm sunlight" />
        </div>
        <div className="auth-foot">
          <span>
            <Layers3 size={16} /> Made for the way you create.
          </span>
          <ArrowUpRight size={22} />
        </div>
      </section>
      <section className="auth-form-wrap">
        <div className="auth-form">
          <span className="mini-mark">f.</span>
          <span className="eyebrow">YOUR CREATIVE SPACE</span>
          <h2>{mode === "login" ? "Welcome back." : "Make room for ideas."}</h2>
          <p>
            {mode === "login"
              ? "Sign in and pick up where inspiration left off."
              : "Create your account. Your first content plan is on us."}
          </p>
          <form onSubmit={submit}>
            {mode === "register" && (
              <label>
                Your name
                <input
                  autoComplete="name"
                  required
                  maxLength={60}
                  value={values.name}
                  onChange={(e) =>
                    setValues({ ...values, name: e.target.value })
                  }
                  placeholder="Alex Morgan"
                />
              </label>
            )}
            <label>
              Email address
              <input
                type="email"
                autoComplete="email"
                required
                value={values.email}
                onChange={(e) =>
                  setValues({ ...values, email: e.target.value })
                }
                placeholder="you@studio.com"
              />
            </label>
            <label>
              Password
              <input
                type="password"
                autoComplete={
                  mode === "login" ? "current-password" : "new-password"
                }
                required
                minLength={8}
                maxLength={72}
                value={values.password}
                onChange={(e) =>
                  setValues({ ...values, password: e.target.value })
                }
                placeholder="At least 8 characters"
              />
            </label>
            {error && (
              <div className="error" role="alert">
                {error}
              </div>
            )}
            <button className="button primary full" disabled={busy}>
              {busy
                ? "Opening your workspace…"
                : mode === "login"
                  ? "Sign in to your workspace"
                  : "Create your workspace"}
              <ArrowRight size={17} />
            </button>
          </form>
          <p className="auth-switch">
            {mode === "login" ? "New to Forma?" : "Already have an account?"}{" "}
            <button
              onClick={() => {
                setMode(mode === "login" ? "register" : "login");
                setError("");
              }}
            >
              {mode === "login" ? "Create an account" : "Sign in"}
            </button>
          </p>
          <div className="auth-note">
            <span className="live-dot" /> One workspace. Every creative
            possibility.
          </div>
        </div>
      </section>
    </div>
  );
}
